import { MicrophoneIcon as HeroMicrophoneIcon } from '@heroicons/react/24/outline';
export const MicrophoneIcon = HeroMicrophoneIcon;
